<template>
  <div class="repair-list" id="repairList">
    <second-menu-link-content>
      <template v-slot:header>
        <span>返修单</span>
      </template>
      <template v-slot:content>
        <div
          v-if="operationList.indexOf(operationsBtns.roleSaleRepairManage)!==-1"
          class="btn-container"
        >
          <el-button class="btn-blue" @click="addOrder">新增</el-button>
        </div>
        <div class="filter-order-condition" ref="filterOrderContainerEle">
          <el-form ref="filterOrderFormEle" :model="optionsForm">
            <div class="container">
              <el-form-item class="item" label="商品筛选：" prop="goodsName">
                <el-input
                  class="white"
                  clearable
                  v-model="optionsForm.goodsName"
                  @keyup.enter.native="filterOrder"
                  placeholder="请输入商品名称"
                ></el-input>
              </el-form-item>
              <el-form-item class="item" label="返修状态：" prop="repairStatus">
                <el-select
                  class="white"
                  v-model="optionsForm.repairStatus"
                  placeholder="请选择返修状态"
                  clearable
                >
                  <el-option
                    v-for="item in repairStatusList"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                class="item item-time"
                label="预计完工时间："
                prop="expectFinishTime"
              >
                <el-date-picker
                  v-model="optionsForm.expectFinishTime"
                  placeholder="请选择时间"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </div>
            <div class="container">
              <el-form-item class="item employeeName" label="经办人：" prop="employeeId">
                <el-select
                  class="white"
                  v-model="optionsForm.employeeId"
                  placeholder="请选择经办人名称"
                  clearable
                  v-loadmore="loadMore"
                >
                  <el-option
                    v-for="item in employeeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="item" label="客户标签：" prop="tagId">
                <el-select
                  class="white"
                  clearable
                  v-model="optionsForm.tagId"
                  placeholder="请选择客户标签"
                >
                  <el-option
                    v-for="(tag, index) in tagList"
                    :key="index"
                    :value="tag.id"
                    :label="tag.name"
                  ></el-option>
                </el-select>
              </el-form-item>
              <div class="userName">
                <el-form-item class="item" label="客户名称：" prop="xbName">
                  <el-autocomplete
                    class="customer-input"
                    v-model="optionsForm.xbName"
                    ref="searchClientByTableEle"
                    type="text"
                    :fetch-suggestions="searchClientByInput"
                    placeholder="请输入客户名或手机号"
                    @select="onSelectClient"
                  >
                    <div class="icon-container" slot="suffix">
                      <svg
                        class="icon"
                        style
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        p-id="3293"
                        width="18"
                        height="18"
                      >
                        <path
                          d="M654.336 483.328c78.336 0 142.336-63.488 142.336-142.336s-63.488-142.336-142.336-142.336c-15.872 0-28.672-12.8-28.672-28.672 0-15.872 12.8-28.672 28.672-28.672 110.08 0 199.168 89.088 199.168 199.168 0 66.56-33.28 129.024-88.576 165.888 118.784 52.736 202.752 188.416 202.752 346.112 0 15.872-12.8 28.672-28.672 28.672h-85.504c-15.872 0-28.672-12.8-28.672-28.672 0-15.872 12.8-28.672 28.672-28.672h55.808c-11.776-160.256-122.368-284.672-254.976-284.672-15.872 0-28.672-12.8-28.672-28.672 0-14.336 12.8-27.136 28.672-27.136z m-349.184 50.688C199.168 466.944 166.912 326.144 233.984 220.16S441.856 81.92 547.84 148.992s138.24 207.36 71.168 313.856c-17.92 28.672-42.496 53.248-71.168 71.168 144.896 54.272 248.32 202.24 248.32 376.32 0 15.872-12.8 28.672-28.672 28.672H85.504c-15.872 0-28.672-12.8-28.672-28.672 0-174.08 103.424-322.56 248.32-376.32z m121.344-22.016c94.208 0 170.496-76.288 170.496-170.496s-76.288-170.496-170.496-170.496C332.288 170.496 256 247.296 256 341.504S332.288 512 426.496 512z m0 56.832c-163.328 0-298.496 137.216-311.808 312.832h623.616c-13.312-175.616-147.968-312.832-311.808-312.832z"
                          p-id="3294"
                          fill="#939393"
                        />
                      </svg>
                    </div>
                  </el-autocomplete>
                </el-form-item>
              </div>
            </div>
            <div class="operations">
              <el-button class="btn-blue" @click="filterOrder">筛选</el-button>
              <el-button
                @click="exportExcel"
                v-if="operationList.indexOf(operationsBtns.roleSaleRepairManage)!==-1"
                class="btn-white"
                >导出报表</el-button
              >
              <span class="reset-btn" @click="clearFilterCondition"
                >清空筛选条件</span
              >
            </div>
          </el-form>
        </div>
        <div class="orders">
          <div class="table" ref="repairList">
            <el-table class="table-container" :data="repairList">
              <el-table-column
                label="创建时间"
                prop="createTime"
                min-width="110"
              ></el-table-column>
              <el-table-column label="客户名称" prop="xbName" 
                min-width="150">
                <template slot-scope="scope">
                  <p :title="scope.row.xbName">{{ scope.row.xbName }}</p>
                </template>
              </el-table-column>
              <el-table-column
                label="商品名称"
                min-width="200"
                prop="goodsName"
              ></el-table-column>
              <el-table-column
                label="商品数量"
                min-width="100"
                prop="quantity"
              ></el-table-column>
              <el-table-column
                label="返修状态"
                min-width="100"
                prop="statusName"
              ></el-table-column>
              <el-table-column label="预计完工时间" prop="expectFinishTime" min-width="125">
                <template slot-scope="scope">
                  <div class="expectFinishTime">
                    <span>{{ scope.row.expectFinishTime }}</span>
                    <span
                      class="replenishment"
                      v-show="scope.row.status == 2 && scope.row.showIcon"
                    >
                      <img
                        src="../../../../assets/inventory/replenishment.png"
                      />
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="打印时间" prop="printTime" min-width="180"></el-table-column>
              <el-table-column label="经办人" prop="employeeName"></el-table-column>
              <el-table-column label="备注" prop="remark" min-width="180"></el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <div class="operation-container" 
                      v-if="operationList.indexOf(operationsBtns.roleSaleRepairManage)!==-1">
                    <span
                      class="column-btn detail-btn"
                      v-if="scope.row.status == 1"
                      @click="openRepair(scope.row.id)"
                      >送修</span
                    >
                    <span
                      class="column-btn detail-btn"
                      v-else-if="scope.row.status == 2"
                      @click="recipient(scope.row.id)"
                      >收货</span
                    >
                    <span
                      class="column-btn detail-btn"
                      v-else
                      @click="openPrinterDialog(scope.row)"
                      >打印</span
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination-tpl-container">
            <pagination-tpl
              :total="totalNum"
              :currentPage="currentPage"
              @queryChange="onQueryChange"
            ></pagination-tpl>
          </div>
        </div>
      </template>
    </second-menu-link-content>
    <el-dialog
      title="送修"
      :visible.sync="dialogVisible"
      width="420px"
      class="repair-dialog"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="预计完工:" prop="repairTime">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="ruleForm.repairTime"
            :picker-options="expireTimeOption"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="repair('ruleForm')">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 打印 -->
    <el-dialog
      class="printer-dialog"
      top="10vh"
      :visible.sync="printerDialog"
      width="760px"
    >
      <div class="printer" id="printer">
        <div class="print-repair">
          <p class="printer-title">返修单</p>
          <div class="printer-message">
            <ul class="list">
              <li class="list-item">
                客户姓名：{{ printDate[0] ? printDate[0].xbName : "" }}
              </li>
              <li class="list-item">收货地址：</li>
            </ul>
            <ul class="list list-right">
              <li class="list-item">收货人：</li>
              <li class="list-item">联系方式：</li>
            </ul>
          </div>
          <div class="table">
            <el-table
              class="table-printer"
              :data="printDate"
              style="width: 100%"
            >
              <el-table-column label="商品名称">
                <template slot-scope="props">
                  <p>{{ props.row.goodsName }}</p>
                </template>
              </el-table-column>
              <el-table-column label="数量" prop="quantity"></el-table-column>
              <el-table-column label="备注" prop="remark"></el-table-column>
            </el-table>
          </div>
          <div class="printer-option-message">
            <p>打印时间：{{ nowDate }}</p>
            <p>操作员：{{ userRealName }}</p>
          </div>
        </div>
      </div>
      <div class="footer">
        <el-button class="btn-white" @click="closePrinterDialog"
          >取消</el-button
        >
        <el-button class="btn-blue" v-print="'#printer'" @click="print"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script >
import { getDBOperationPermission, getDBUserRealName } from "common/js/storage";
import { formatTimeToDate, formaTimeToSecond } from "common/js/util.js";
import PaginationTpl from "base/PaginationTpl";
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import DBOrder from "models/db/order.js";
import DBExcel from "models/db/excel.js";
import DBClient from "models/db/client.js";
import DBSiteSet from 'models/db/site-set.js';
const dbSiteSet = new DBSiteSet();
const dbClient = new DBClient();
const dbOrder = new DBOrder();
const dbExcel = new DBExcel();
// 页面按钮--订单导出 新增订单
const EXPORT_ORDER = "ROLE_ORDER_export";
const ADD_ORDER = "ROLE_ORDER_add";
export default {
  data() {
    return {
      // 页面按钮权限--送修、打印、收货
      operationsBtns: {
        roleSaleRepairManage: "ROLE_ORDER_repair_manage"
      },
      //设置当前时间前不可选
      expireTimeOption: {
        disabledDate(date) {
          //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      // 当前页面
      currentPage: 1,
      // 订单总条数
      totalNum: 0,
      // 筛选条件表单
      optionsForm: {
        repairStatus: "",
        goodsName: "",
        // 筛选条件--预计完工时间
        expectFinishTime: "",
        userId: "",
        employeeId: "", //经办人id
        tagId: ""
      },
      // 所有返修单状态
      repairStatusList: [
        {
          label: "返修入库",
          id: 1,
        },
        {
          label: "送修出库",
          id: 2,
        },
        {
          label: "完修入库",
          id: 3,
        },
        {
          label: "返修完成",
          id: 4,
        },
      ],
      //经办人列表
      employeeList:[],
      // 返修单列表
      repairList: [],
      // 具体查询参数
      options: {
        // 当前页面
        currentPage: 1,
        // 筛选条件--订单状态
        status: "",
        // 筛选条件--预计完工时间
        expectFinishTime: "",
        goodsName: "",
        employeeId: "", //经办人id
        tagId: ""
      },
      // 页面操作按钮
      operationBtns: {
        exportOrderBtn: EXPORT_ORDER,
        addOrderBtn: ADD_ORDER,
      },
      // 用户权限列表
      operationList: [],
      dialogVisible: false,
      ruleForm: {
        repairTime: "",
      },
      rules: {
        repairTime: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
      },
      selelctRepairId: "",
      printerDialog: false,
      printDate: [],
      nowDate: "",
      userRealName: "",
      selectedXbId: "",
      employeePage: 1,
      isLoadMore: false,
      tagList: []
    };
  },
  watch: {
    printerDialog: {
      handler(newVal) {
        if (newVal) {
          let date = new Date();
          this.nowDate = formaTimeToSecond(date.getTime());
          this.userRealName = getDBUserRealName()
            ? getDBUserRealName()
            : "暂无";
        }
      },
    },
  },
  methods: {
    _getClientTagList(currentPage) {
      dbClient
        .getClientTagList(currentPage)
        .then((res) => {
          if (res.success) {
            // 先置空
            this.tagList = [];
            res.result.map((item) => {
              if (item.id !== -1) {
                this.tagList.push({
                  id: item.id,
                  name: item.value,
                });
              }
            });
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((e) => {
          console.log("客户标签列表异常", e);
        });
    },
    onQueryChange(query) {
      // 翻页
      this.options.currentPage = query.currentPage;
      this._getDBRepairOrderList(this.options);
    },
    // 筛选订单
    filterOrder() {
      this.currentPage = 1;
      this.options = Object.assign(this.options, {
        currentPage: this.currentPage,
        status: this.optionsForm.repairStatus,
        goodsName: this.optionsForm.goodsName,
        expectFinishTime: this.optionsForm.expectFinishTime,
        userId: this.selectedXbId,
        employeeId: this.optionsForm.employeeId,
        labelId: this.optionsForm.tagId,
      });
      this._getDBRepairOrderList();
    },
    // 导出返修单表单
    exportExcel() {
      let expectFinishTime = this.options.expectFinishTime;
      let status = this.options.status;
      let currentPage = this.options.currentPage;
      let goodsName = this.options.goodsName;
      let labelId = this.options.labelId;
      let options = {
        expectFinishTime,
        status,
        currentPage,
        goodsName,
        labelId
      };
      dbExcel.getRepairExcel(options).then((res) => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      });
    },
    clearFilterCondition() {
      this.selectedXbId = ''
      this.$refs.filterOrderFormEle.resetFields();
      this.filterOrder();
    },
    addOrder() {
      this.$router.push({
        path: "/admin/order/repair-form/add-repair",
      });
    },
    openRepair(id) {
      this.selelctRepairId = id;
      this.dialogVisible = true;
    },
    //送修
    repair(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: this.selelctRepairId,
            time: this.ruleForm.repairTime,
          };
          dbOrder.repairOut(data).then((res) => {
            if (res.success) {
              this.dialogVisible = false;
              this._getDBRepairOrderList();
            } else {
              this.$message({
                message: res.message,
                center: true,
                type: "error",
                duration: 1000,
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //收货
    recipient(id) {
      this.$confirm("是否确认已收到厂家修理完工的返修件？", "收货", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        let data = {
          id: id,
        };
        dbOrder.repairReceive(data).then((res) => {
          if (res.success) {
            this._getDBRepairOrderList();
          } else {
            this.$message({
              message: res.message,
              center: true,
              type: "error",
              duration: 1000,
            });
          }
        });
      });
    },
    // 获取所有返修单列表
    _getDBRepairOrderList() {
      dbOrder.getRepairList(this.options).then((res) => {
        if (res.success) {
          this.totalNum = res.result.totalNum;
          let arr = [];
          let date = new Date();
          let dateTime = date.toLocaleDateString();
          res.result.items.map((item) => {
            let obj = {};
            obj.createTime = formatTimeToDate(item.createTime);
            obj.xbName = item.xbName;
            obj.id = item.id;
            obj.goodsName = item.goodsName;
            obj.quantity = item.quantity;
            obj.employeeName = item.employeeName;
            obj.printTime = item.printTime;
            obj.status = item.status;
            this.repairStatusList.map((v) => {
              if (v.id == item.status) {
                obj.statusName = v.label;
              }
            });
            if (
              Number(new Date(dateTime)) >
              Number(new Date(item.expectFinishTime))
            ) {
              obj.showIcon = true;
            } else {
              obj.showIcon = false;
            }
            if (item.expectFinishTime) {
              obj.expectFinishTime = formatTimeToDate(item.expectFinishTime);
            } else {
              obj.expectFinishTime = "";
            }
            obj.remark = item.message;
            arr.push(obj);
          });
          this.repairList = arr;
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    repairPrint() {
      let ids = [this.printDate[0].id];
      let data = {
        ids: ids,
        orderCode: "",
      };
      dbOrder.repairPrint(data).then((res) => {
        if (res.success) {
          this._getDBRepairOrderList();
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    openPrinterDialog(row) {
      this.printDate = [row];
      this.printerDialog = true;
    },
    closePrinterDialog() {
      this.printerDialog = false;
    },
    print() {
      this.repairPrint();
    },
    // 输入框查询客户
    searchClientByInput(query, cb) {
      if (query === "") {
        this.selectedXbId = 0;
      }
      let options = {
        name: query,
        isDiffAuth: 0
      };
      this._searchClientByInput(options, cb);
    },
    // 根据客户姓名关键字查询客户
    _searchClientByInput(options, cb) {
      dbClient.getClientList(options).then((res) => {
        console.log(res);
        if (res.success) {
          this.serachClientList = [];
          res.result.items.map((item) => {
            if (item.name || item.telephone) {
              this.serachClientList.push({
                value: `${item.name ? item.name + ";" : ""}${item.telephone}`,
                id: item.userId,
              });
            }
          });
          cb(this.serachClientList);
        }
      });
    },
    onSelectClient(item) {
      this.selectedXbId = item.id;
    },
    remove_ie_header_and_footer() {
      console.log(9900);
      var hkey_root, hkey_path, hkey_key;
      hkey_path = "HKEY_CURRENT_USER\\Software\\Microsoft\\Internet Explorer\\PageSetup\\";
      try {
          var RegWsh = new ActiveXObject("WScript.Shell");
          RegWsh.RegWrite(hkey_path + "header", "");
          RegWsh.RegWrite(hkey_path + "footer", "");
      } catch (e) {}
    },
    // 获取经办人列表数据
    getTableData() {
      let page = this.employeePage;
      dbSiteSet.getDBEmployee(page).then(res => {
        if (res.success) {
          let arr = [];
          res.result.items.map((value, index, array) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.contact;
            arr.push(obj);
          });
          this.employeeList = this.employeeList.concat(arr);
          let total = page*res.result.pageSize
          if (total>=res.result.totalNum) {
            this.isLoadMore = true
          }
        }
      });
    },
    loadMore() {
      if (!this.isLoadMore) {
        this.employeePage++
        this.getTableData()
      }
    }
  },
  created() {
    this.remove_ie_header_and_footer()
    this._getDBRepairOrderList();
    this.getTableData()
    this.operationList = getDBOperationPermission();
    this._getClientTagList()
  },
  components: {
    PaginationTpl,
    SecondMenuLinkContent,
  },
};
</script>

<style lang="scss" scoped>
.repair-list {
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: rgba(96, 98, 102, 1);
  .filter-order-condition {
    margin-top: 16px;
    padding: 16px;
    background: rgba(245, 247, 250, 1);
    border-radius: 4px;
    .container {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      padding-left: 14px;
      .item {
        margin-right: 24px;
      }
    }
    .operations {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 80px;
      .el-button + .el-button {
        margin-left: 16px;
      }
      .btn-white {
        width: 128px;
        letter-spacing: 4px;
      }
      .reset-btn {
        cursor: pointer;
        font-size: 12px;
        font-family: "PingFangSC-Regular";
        font-weight: 400;
        color: rgba(61, 116, 242, 1);
        margin-left: 20px;
      }
    }
  }
  .orders {
    margin-top: 24px;
    .column-btn {
      font-size: 12px;
      font-family: "PingFangSC-Regular";
      font-weight: 400;
      color: rgba(61, 116, 242, 1);
      cursor: pointer;
      margin-right: 16px;
    }
    .replenishment {
      margin-left: 11px;
      img {
        padding-bottom: 3px;
      }
    }
    .pagination-tpl-container {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}
</style>
<style lang="scss">
#repairList {
  .el-form {
    .el-form-item {
      display: flex;
      .el-form-item__content {
        width: 160px;
      }
    }
    .item-time {
      .el-form-item__label {
        width: 105px;
      }
      .el-form-item__content {
        width: 220px;
      }
    }
  }
  .table {
    box-sizing: border-box;
    .el-table {
      width: 100%;
      overflow: auto;
      box-sizing: border-box;
      .el-table__body-wrapper {
        .el-table__body {
          padding-bottom: 0px;
        }
      }
      .el-table__fixed-right {
        .el-table__header {
          thead {
            tr {
              th:nth-child(7) {
                box-sizing: border-box;
                padding: 0;
                margin: 0;
                .cell {
                  height: 32px;
                }
                background: rgba(245, 247, 250, 1);
              }
            }
          }
        }
        .el-table__body {
          padding-bottom: 10px;
          tbody {
            tr {
              td:nth-child(7) {
                padding: 0;
                margin: 0;
                height: 32px;
                .cell {
                  height: 32px;
                }
              }
            }
          }
        }
      }
      .el-table__fixed-right {
        box-shadow: -3px 0px 8px 0px rgba(0, 0, 0, 0.11);
        th {
          .cell {
            text-align: center;
          }
        }
        td {
          padding: 0;
          .cell {
            height: 32px;
            line-height: 32px;
            padding: 0 16px;
            display: flex;
            justify-content: space-between;
            .up-down-update {
              flex: 2;
              display: flex;
              justify-content: space-around;
              .update {
                margin-right: 5px;
              }
            }
            > .el-button {
              flex: 1;
            }
          }
          background: rgba(245, 247, 250, 1);
          .el-button--text {
            color: #3d74f2;
            font-size: 12px;
          }
        }
      }
    }
  }
  .repair-dialog {
    .el-dialog__header {
      height: 46px;
      border-bottom: 1px solid #eee;
      .el-dialog__title {
        font-size: 16px;
        font-weight: bold;
        color: #666666;
        line-height: 24px;
      }
    }
    .el-form-item__content {
      margin-left: 10px !important;
      width: 250px !important;
    }
    .el-dialog__footer {
      height: 72px;
      line-height: 56px;
      border-top: 1px solid #eee;
      text-align: center;
    }
    .el-dialog__body {
      height: 72px;
      display: flex;
      align-items: center;
      padding-bottom: 0px;
    }
    .el-dialog {
      margin-top: 0;
      top: 30%;
      transform: translate(0, -50%);
    }
  }
  .printer-dialog {
    .el-dialog__body {
      max-height: 80vh;
      overflow: auto;
      .footer {
        height: 64px;
        box-sizing: border-box;
        padding-top: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .container {
    .el-form-item__label {
      width: 75px;
    }
    .userName {
      .el-autocomplete,
      .el-input,
      .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
      .el-input__suffix {
        padding-top: 4px;
      }
      .el-form-item {
        .el-form-item__label {
          width: 105px;
        }
        .el-form-item__content {
          width: 260px;
        }
      }
    }
  }
}
</style>
<style midia="print">
@page{
  size:  auto;
  margin-top: 3mm;
  margin-bottom: 3mm;
}
#printer .printer-title {
  height: 64px;
  font-size: 24px;
  line-height: 64px;
  text-align: center;
}
#printer .printer-message {
  display: flex;
  justify-content: space-between;
}
#printer .printer-message .list .list-item {
  font-size: 12px;
  padding-bottom: 16px;
}
#printer .printer-message .list .list-right {
  width: 250px;
}
#printer .print-repair .list-right {
  margin-right: 160px;
}
#printer .table .price {
  display: flex;
  height: 32px;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  border: 1px #000 solid;
  border-top: 0;
}
#printer .table .el-table {
  border: 1px solid #000;
}
#printer .el-table th.is-leaf {
  border-bottom: 1px solid #000;
}
#printer .table .el-table td {
  border-bottom: 1px solid #000;
}
#printer .table .price .price-left {
  display: flex;
}
#printer .table .price .price-left p {
  margin: 0 16px;
}
#printer .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
  height: auto;
  line-height: 20px;
  font-size: 12px;
}
#printer .table .price .price-right {
  display: flex;
}
#printer .table .price .price-right p {
  margin-right: 16px;
}
#printer .table th {
  width: 60px;
}
#printer .remark {
  display: flex;
  height: 32px;
  font-size: 12px;
  border: 1px #000 solid;
  line-height: 32px;
  border-top: 0;
}
#printer .remark .remark-title {
  width: 100px;
  border-right: 1px #000 solid;
  text-align: center;
}
#printer .remark .remark-content {
  padding-left: 10px;
}
#printer .printer-option-message {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  font-size: 12px;
}
#printer .printer-logistics {
  margin-top: 30px;
  border: 1px solid rgba(96, 98, 102, 1);
  border-bottom: 0;
  border-radius: 8px 8px 0px 0px;
}
#printer .printer-logistics .logistics-list {
  display: flex;
  min-height: 30px;
  border-bottom: 1px solid rgba(96, 98, 102, 1);
}
#printer .printer-logistics .logistics-list .logistics-item:first-child {
  border-right: 1px solid rgba(96, 98, 102, 1);
}
#printer .printer-logistics .logistics-list .logistics-item {
  flex: 1;
  min-height: 30px;
  line-height: 30px;
  padding-left: 16px;
}
#printer .printer-logistics .logistics-list .logistics-item.border0 {
  border-right: 0;
}
</style>